/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { createRelayResource } from '@atlassian/atlassian-studio-common';
import bootstrapHubQuery from '../../ui/bootstrap/__generated__/bootstrapHubQuery.graphql';
import hubHomeQuery from '../../ui/hub-home/__generated__/hubHomeQuery.graphql';
export var bootstrapHubResource = createRelayResource({
  getQuery: function getQuery(routerContext) {
    var cloudId = routerContext.match.params.cloudId;
    return {
      query: bootstrapHubQuery,
      variables: {
        cloudId: cloudId !== null && cloudId !== void 0 ? cloudId : ''
      }
    };
  }
});
export var hubHomeResource = createRelayResource({
  getQuery: function getQuery(routerContext) {
    var cloudId = routerContext.match.params.cloudId;
    return {
      query: hubHomeQuery,
      variables: {
        // temporary hardcoded (homepageId for hub on PUG)
        pageId: "ari:cloud:confluence:".concat(cloudId, ":page/453436542084")
      }
    };
  }
});